(function () {
  var el = document.getElementById('noticeText');
  if (!el) return;

  var messages;
  try {
    messages = JSON.parse(el.getAttribute('data-messages') || '[]');
  } catch (e) {
    messages = [];
  }
  messages = messages.filter(function (m) { return m && m.length; });
  if (messages.length < 2) return;

  var idx = 0;
  var intervalMs = 4000;
  var fadeMs = 350;

  setInterval(function () {
    el.classList.add('is-fading');
    setTimeout(function () {
      idx = (idx + 1) % messages.length;
      el.textContent = messages[idx];
      el.classList.remove('is-fading');
    }, fadeMs);
  }, intervalMs);
})();